module.exports = __webpack_public_path__ + "static/media/workflow.9f11766a.svg";